import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Clock, MapPin, Facebook, Instagram, Youtube } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { TikTokIcon, XIcon } from "@/components/site/Icons";

export default function Footer() {
  const { settings, t } = useSite();
  const s = settings || {};
  const year = new Date().getFullYear();
  const socials = [
    ["facebook", Facebook], ["instagram", Instagram], ["tiktok", TikTokIcon], ["youtube", Youtube], ["x", XIcon],
  ].filter(([k]) => s.social?.[k]);

  return (
    <footer style={{ backgroundColor: "var(--footer)" }} className="text-white/80" data-testid="site-footer">
      <div className="max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <h3 className="text-xl font-bold accent-text mb-4">{s.site_name}</h3>
          <p className="text-sm leading-relaxed">{s.footer_about}</p>
          <div className="flex gap-3 mt-6">
            {socials.map(([k, Icon]) => (
              <a key={k} href={s.social[k]} target="_blank" rel="noreferrer" aria-label={k} data-testid={`footer-social-${k}`}
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[var(--brand)] flex items-center justify-center transition-colors duration-200">
                <Icon className="w-4 h-4 text-white" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h3 className="text-xl font-bold accent-text mb-4">{t("contact")}</h3>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3"><Phone className="w-4 h-4 accent-text mt-0.5 shrink-0" /><div><div>{s.phone}</div><div className="text-xs text-white/60">{t("whatsappAvailable")}</div></div></li>
            <li className="flex gap-3"><Mail className="w-4 h-4 accent-text mt-0.5 shrink-0" /><a href={`mailto:${s.email}`} className="hover:text-white break-all">{s.email}</a></li>
            <li className="flex gap-3"><Clock className="w-4 h-4 accent-text mt-0.5 shrink-0" /><div><div>{s.hours_days}</div><div>{s.hours_time}</div></div></li>
          </ul>
        </div>
        <div>
          <h3 className="text-xl font-bold accent-text mb-4">{t("location")}</h3>
          <div className="flex gap-3 text-sm"><MapPin className="w-4 h-4 accent-text mt-0.5 shrink-0" /><div><div>{s.address_line1}</div><div>{s.address_line2}</div><div>{s.address_line3}</div></div></div>
        </div>
        <div>
          <h3 className="text-xl font-bold accent-text mb-4">{t("quickLinks")}</h3>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-white transition-colors">{t("home")}</Link></li>
            <li><Link to="/excursiones" className="hover:text-white transition-colors">{t("tours")}</Link></li>
            <li><Link to="/#comentarios" className="hover:text-white transition-colors">Comentarios</Link></li>
            <li><Link to="/#contacto" className="hover:text-white transition-colors">{t("contact")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row gap-2 justify-between text-sm text-white/70">
          <span>© {year} {s.site_name}. {t("rights")}</span>
          <span>Pagos seguros con <span className="accent-text font-semibold">Stripe</span></span>
        </div>
      </div>
    </footer>
  );
}
